import { useState, useEffect } from 'react'
import { Box, Card, CardContent, Grid } from '@mui/material'
import Form from './promotion-form'
import { useSelector } from 'react-redux'
import FormComplete from './promotional-form-complete'
import { PageLoader, StyledModal, AnimatedErrorCross } from 'frame/components'

const PromotionBanner = () => {

  const [showError, setShowError] = useState(false)

  const flags = useSelector(state => state?.fbtSubmissions?.flags)
  const errorMessage = useSelector(state => state?.fbtSubmissions?.errorMessage)

  useEffect(() => {
    flags.registerInterest === 'error' && setShowError(true)
  }, [flags.registerInterest])

  return (
    <Card
      sx={{
        backgroundColor: '#002849',
        height: 'calc(100vh - 224px)',
        '@media (max-width:600px)': {
          height: '100%',
        },
      }}>
      <CardContent>
        <Grid container spacing={3}>
          <Grid
            sx={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
            item xs={12}>
            <Box
              component="img"
              src="/static/images/logo-light.png"
              alt="logo"
              sx={{
                width: 400,
                height: 'auto',
                '@media (min-width:600px)': {
                  padding: '3rem 0',
                },
                '@media (max-width:600px)': {
                  width: 350,
                },
                '@media (max-width:0px)': {
                  width: 250,
                },
              }}/>
          </Grid>

          {flags?.registerInterest === 'processed' ? (
            <Grid item xs={12}>
              <FormComplete />
            </Grid>
          ) : flags?.registerInterest === 'processing' ? (
            <Grid
              sx={{
                height: 490
              }}
              item xs={12}>
              <PageLoader color={'#FFF'} />
            </Grid>
          ) : (
            <Form />
          )}
        </Grid>
      </CardContent>

      {/* Error Message Popup */}
      <StyledModal
        open={showError}
        onCancel={() => setShowError(false)}
        options={['noButtons']}
        animatedIcon={<AnimatedErrorCross size={50} />}>
        {`Register Interest Failed.${errorMessage ? ` Error: ${errorMessage}` : ''}`}
      </StyledModal>
    </Card>
  )
}

export default PromotionBanner
